<template>
  <textarea
    :class="['atom-textarea', { 'atom-textarea--error': hasError }]"
    :placeholder="placeholder"
    :disabled="disabled"
    :rows="rows"
    :maxlength="maxlength"
    :value="value"
    @input="handleInput"
    @blur="handleBlur"
    @focus="handleFocus">
  </textarea>
</template>

<script>
  export default {
    name: "AtomTextarea",
    props: {
      value: {
        type: String,
        default: "",
      },
      placeholder: {
        type: String,
        default: "",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      hasError: {
        type: Boolean,
        default: false,
      },
      rows: {
        type: Number,
        default: 1,
      },
      maxlength: {
        type: Number,
        default: null,
      },
      maxRows: {
        type: Number,
        default: null,
      },
    },
    mounted() {
      if (this.maxRows) this.autoResize(this.$el);
    },
    methods: {
      autoResize(el) {
        const style = getComputedStyle(el);
        const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2;
        const paddingTop = parseFloat(style.paddingTop);
        const paddingBottom = parseFloat(style.paddingBottom);
        const maxHeight = lineHeight * this.maxRows + paddingTop + paddingBottom;
        el.style.height = "auto";
        const next = Math.min(el.scrollHeight, maxHeight);
        el.style.height = next + "px";
        el.style.overflowY = el.scrollHeight > maxHeight ? "auto" : "hidden";
      },
      handleInput(event) {
        if (this.maxRows) this.autoResize(event.target);
        this.$emit("input", event.target.value);
      },
      handleBlur(event) {
        this.$emit("blur", event);
      },
      handleFocus(event) {
        this.$emit("focus", event);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .atom-textarea {
    width: 100%;
    padding: 8px 8px 8px 11px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-family: $newFont_regular;
    font-weight: 400;
    font-size: 16px;
    resize: none;
    outline: none;
    overflow-y: hidden;
    color: #3d3d3d;
    transition: border-color 0.2s;

    &:focus {
      border-color: $primary-color;
    }

    &:disabled {
      background-color: #f5f5f5;
      cursor: not-allowed;
    }

    &::placeholder {
      color: #818181;
    }
  }
</style>
